import React from "react";
import { CONSTANTS } from "utils/constant";
import { Card } from "antd";
import api from "utils/api";

class FinishConsultation extends React.Component {
    constructor(props) {
        super(props)
    }
    getMessage() {
        const {
            case_notes,
            prescription_done,
            diagnosis_done,
            prescription_report_done
        } = this.props;

        const allFilled = case_notes && prescription_done && diagnosis_done;
        const anyNotFilled = !case_notes || !prescription_done || !diagnosis_done;
        const prescriptionReportPublished = prescription_report_done;

        if (prescriptionReportPublished && allFilled) {
            return "Thank you! You have filled all the required ones and Published the Prescription report.";
        } else if (prescriptionReportPublished && anyNotFilled) {
            return "Thank you! You have Published the Prescription report but not filled the required ones.";
        } else if (!prescriptionReportPublished && allFilled) {
            return "Thank you! You have filled all the required ones but not Published the Prescription report.";
        } else if (!prescriptionReportPublished && anyNotFilled) {
            return "Thank you! You have not filled the required ones and not published the Prescription Report.";
        } else if (prescriptionReportPublished) {
            return "Thank You! You have Published the Prescription Report";
        }
    }
    render() {
        return (
            <>
                <div style={{ marginBottom: '0px', fontWeight:"bold" ,color: '#333' }}>
                        {this.getMessage()}
                </div>
                <div style={{fontWeight:"bold",color: '#333'}}>
                  {CONSTANTS.FINISH_CONSULTATION_HEADING}
                </div>
                <div className="finish-consultation-modal-card" >
                        <Card className="modal-card " title="Filled" headStyle={{borderBottom: "2px solid #4F7A21"}} >
                            <div>
                            {this.props.case_notes ?
                                <p>{CONSTANTS.CASENOTES}</p>
                                : null
                            }
                            {this.props.prescription_done ?
                                <p>{CONSTANTS.PRESCRIPTION}</p>
                                : null
                            }
                          
                            {this.props.diagnosis_done ?
                                <p>{CONSTANTS.DIAGNOSIS}</p>
                                : null
                            }
                            {(this.props.patientEvaluated) ? this.props.followupConsultation ?
                                <p>{CONSTANTS.FOLLOW_UP}</p>
                                : null :null
                            }
                            {(this.props.patientEvaluated) ?this.props.doctor_referral_done ?
                                <p>{CONSTANTS.DOCTOR_REFERRAL}</p>
                                : null : null
                            }
                            </div>
                        </Card>
                        <Card className="modal-card" title="Not Filled"  headStyle={{borderBottom: "2px solid #F04438"}}>
                            <div>
                            {this.props.case_notes ?
                                null :
                                <p>{CONSTANTS.CASENOTES}</p>
                            }
                            {this.props.prescription_done ?
                                null :
                                <p>{CONSTANTS.PRESCRIPTION}</p>
                            }
                           
                           
                           
                          
                            
                            {this.props.diagnosis_done ?
                                null :
                                <p>{CONSTANTS.DIAGNOSIS}</p>
                            }
                            {(this.props.patientEvaluated) ? this.props.followupConsultation? 
                                null: 
                                <p>{CONSTANTS.FOLLOW_UP}</p> : null
                            }
                            {(this.props.patientEvaluated) ? this.props.doctor_referral_done ?
                                null :
                                <p>{CONSTANTS.DOCTOR_REFERRAL}</p> : null
                            }
                           
                            </div>
                        </Card>
                        <Card className="modal-card" title="Published"  headStyle={{borderBottom: "2px solid #15B79E"}}>
                            {this.props.prescription_report_done ?
                                <p>{CONSTANTS.PRESCRIPTION_REPORT}</p>
                                : null
                            }
                            {this.props.evaluation_publish ?
                                <p>{CONSTANTS.EVALUATION_REPORT}</p>
                                : null
                            }
                          
                        </Card>
                        <Card className="modal-card" title="Not Published"  headStyle={{borderBottom: "2px solid #DC6803"}}>
                            {this.props.prescription_report_done ?
                                null :
                                <p>{CONSTANTS.PRESCRIPTION_REPORT}</p>

                            }
                           
                           
                        </Card>
                </div>
            </>
        )
    }
}
export default FinishConsultation